/* eslint-disable @typescript-eslint/no-unused-expressions */
import { progressApi } from "utilities/Axios";

function subtractHours(date: any) {
  date.setHours(date.getHours() - 720);
  return date;
}

const dateNow = new Date();
const dateTime = subtractHours(dateNow);

export const getAllTags = () => {
  return progressApi.get("/TagMeta/GetAllTags");
};

export const getTagData = (
  ids: any,
  dateTime?: string,
) => {
  let url = "Dashboard/GetTagData";
  dateTime ? (url += `?dateTime=${dateTime}`) : null;
  return progressApi.post(url, ids);
};

export const mapEquipmentTag = (tags: any) => {
  return progressApi.post("/TagMeta/MapEquipmentTag", tags);
};

export const getAllTagsWithParents = () => {
  return progressApi.get("/TagMeta/GetAllTagsWithParent");
};

export const createTag = (tag: any) => {
  return progressApi.post("/TagMeta/CreateTag", tag);
};

export const updateTag = (tag: any) => {
  return progressApi.post("/TagMeta/UpdateTag", tag);
};

export const resetTag = (id: any) => {
  return progressApi.get(`/TagMeta/ResetTagRange?id=${id}`);
};

export const uploadTag = (data: any, signal: any) => {
  return progressApi.post("TagData/Upload", data);
};

export const deleteTag = (id: any) => {
  return progressApi.get(`/TagMeta/DeleteTag?id=${id}`);
};

export const getTrainsByPlantId = (id: any) => {
  return progressApi.get(`/TagMeta/GetTrainsByPlantId?id=${id}`);
};

export const disableTag = (tagId: number, status: any) => {
  return progressApi.post(
    `/TagMeta/SetTagDisabled?tagId=${tagId}&isDisabled=${status}`
  );
};

export const getTagsByEquipmentsId = (equipmentId: any) => {
  return progressApi.get(`/TagMeta/GetTagsByEquipmentsId?id=${equipmentId}`);
};

export const downloadTag = (id: any) => {
  return progressApi.get(`/TagData/DownloadTagData?id=${id}`);
};

export const clearTag = (id: any) => {
  return progressApi.get(`/TagData/ClearTagData?id=${id}`);
};
